<div class="row">
	<div class="col-15 col-md-15 col-sm-24">
		<!-- Title -->
		<div class="margin-bottom-10">
			<ngx-skeleton-loader [theme]="{ width: '60%', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
		</div>
	</div>
	<div class="col-24 col-md-24 col-sm-24">
		<!-- row -->
		<ng-container *ngIf="GHOST_ROWS">
			<div *ngFor="let row of GHOST_ROWS">
				<ngx-skeleton-loader [theme]="{ width: '90%', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</div>
		</ng-container>
	</div>
</div>
